// Components/Header.js — JCUMAS 060.013
import React from "react";

const Header = ({ subtitle = "Área de Gestión" }) => {
  return (
    <header className="mb-4" style={{ backgroundColor: "#ffffff", borderBottom: "1px solid var(--sp-border-strong)" }}>
      <nav className="navbar navbar-expand navbar-light px-3">
        <div className="navbar-brand d-flex align-items-center">
          <span className="fw-bold text-primary">JCUMAS 060.013</span>
          <span className="text-muted ms-2">{subtitle}</span>
        </div>
      </nav>
    </header>
  );
};

export default Header;
